const slots = new Map()
import { path } from 'ramda'

slots.set('description', ctx => ({
  key: 'description',
  defaultPlacement: 'presentation',
  component: 'InputComponent',
  props: {
    label: ctx.labels.description,
    required: true,
  },
  slots: {
    default: [{ component: 'RichTextComponent' }],
  },
}))

slots.set('media.logo', ctx => ({
  component: 'MediaComponent',
  key: 'media.logo',
  defaultPlacement: 'presentation',
  props: {
    label: ctx.labels['media.logo'],
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: 'logo' },
    enableDescription: false,
    enableAlt: false,
  },
}))

slots.set('media.logoInverted', ctx => ({
  key: 'media.logoInverted',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels['media.logoInverted'],
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: 'logo' },
    enableDescription: false,
    enableAlt: false,
  },
}))

slots.set('media.favicon', ctx => ({
  key: 'media.favicon',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels.favicon,
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: { maxWidth: 200 } },
    enableDescription: false,
    enableAlt: false,
  },
}))
slots.set('media.cover', ctx => ({
  key: 'media.cover',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels.cover,
    placement: 'outside',
    size: 'contain',
    multiple: 'multiple',
    uploadOptions: { compression: 'gallery' },
    types: ctx.types,
    required: true,
    enableFocusPoint: true,
  },
  slots: {
    ['after-label']: [{ component: 'MediaRecommendation', props: { value: 'cover' } }],
  },
}))

slots.set('media.gallery', ctx => ({
  key: 'media.gallery',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels.gallery,
    placement: 'outside',
    size: 'contain',
    multiple: 'multiple',
    uploadOptions: { compression: 'gallery' },
    types: ctx.types,
    enableFocusPoint: true,
  },
  slots: {
    ['after-label']: [{ component: 'MediaRecommendation', props: { value: 'gallery' } }],
  },
}))

slots.set('media.brochure', ctx => ({
  key: 'media.brochure',
  defaultPlacement: 'presentation',
  component: 'FileComponent',
  props: {
    label: ctx.labels.brochure,
    multiple: 'multiple',
    accept: '.pdf',
  },
  slots: {
    ['drop-message']: [{ component: 'FileOnDrop' }],
  },
}))

slots.set('media.attachments', ctx => ({
  key: 'media.attachments',
  defaultPlacement: 'presentation',
  component: 'FileComponent',
  props: {
    label: ctx.labels.attachments,
    multiple: 'multiple',
  },
}))

slots.set('theme', ctx => ({
  key: 'theme',
  defaultPlacement: 'theme',
  component: 'ThemeSelector',
  props: {
    data: ctx.data,
    'data-field': 'theme',
  },
}))

slots.set('themeColor', ctx => ({
  key: 'themeColor',
  defaultPlacement: 'theme',
  component: 'ColorSelector',
  props: {
    label: ctx.$t('primaryColor'),
    'data-field': 'themeColor',
  },
}))

slots.set('themeColorSecondary', ctx => ({
  key: 'themeColorSecondary',
  defaultPlacement: 'theme',
  component: 'ColorSelector',
  props: {
    label: ctx.$t('secondaryColor'),
    'data-field': 'themeColorSecondary',
  },
}))

slots.set('settings', ctx => ({
  key: 'metadata.siteSettings',
  defaultPlacement: 'theme',
  component: 'PageSettings',
  props: {
    data: ctx.data,
    label: ctx.$t('settings'),
    'data-field': 'settings',
  },
}))

slots.set('flatfinder', ctx => ({
  key: 'flatfinder',
  defaultPlacement: 'flatfinder',
  component: 'Flatfinder',
  props: {
    'data-field': 'flatfinder',
  },
}))

slots.set('publishing', ctx => {
  return {
    key: 'publishing',
    defaultPlacement: 'publishing',

    component: 'Publishing',
    props: {
      data: ctx.data,
    },
  }
})

export default slots
